import type { ComponentTheme } from '../types/component-theme';

import { ThemeVariants } from './constants/theme-variants';

export default {
    slots: {
        root: 'relative z-30 min-w-0 p-4',
        field: 'flex h-full min-w-0 w-full items-stretch overflow-hidden rounded-xl border',
        textarea:
            'w-0 min-w-0 flex-1 resize-none border-0 bg-transparent px-4 py-3 text-sm outline-none ' +
            'disabled:cursor-not-allowed disabled:opacity-100',
        readOnlyMessage: 'flex min-w-0 flex-1 items-center px-4 text-sm',
        sendButton: 'shrink-0'
    },
    variants: {
        theme: {
            [ThemeVariants.Dark]: {
                root: 'bg-slate-900',
                field: 'border-white/10 bg-slate-800/80',
                textarea: 'text-white placeholder:text-slate-400',
                readOnlyMessage: 'text-slate-300'
            },
            [ThemeVariants.Light]: {
                root: 'bg-white',
                field: 'border-slate-300/70 bg-slate-50',
                textarea: 'text-slate-800 placeholder:text-slate-400',
                readOnlyMessage: 'text-slate-600'
            }
        },
        responseUnavailable: {
            true: {
                sendButton: 'shadow-none!'
            }
        }
    },
    compoundVariants: [
        {
            theme: ThemeVariants.Dark,
            responseUnavailable: true,
            class: {
                field: 'border-indigo-400/20 bg-indigo-950/25 shadow-[inset_0_0_0_1px_rgba(129,140,248,0.05)]',
                textarea:
                    'text-indigo-200 placeholder:text-indigo-300/60 disabled:text-indigo-100/45 ' +
                    'disabled:placeholder:text-indigo-200/35',
                sendButton: 'bg-indigo-950/45! text-indigo-200/35!'
            }
        },
        {
            theme: ThemeVariants.Light,
            responseUnavailable: true,
            class: {
                field: 'border-slate-300 bg-slate-200/70 shadow-[inset_0_0_0_1px_rgba(148,163,184,0.18)]',
                textarea:
                    'text-slate-500 placeholder:text-slate-500 disabled:text-slate-250/45 ' +
                    'disabled:placeholder:text-slate-400/35',
                sendButton: 'bg-slate-200/80! text-slate-500!'
            }
        }
    ]
} satisfies ComponentTheme;
